import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { UniversalSearchComponent } from './universal-search.component';

import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';
import { ClientPickerModule } from '../../components/smr-client-picker/smr-client-picker.module';
import { StylistPickerModule } from '../../components/stylist-picker/stylist-picker.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    IonicModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    ClientPickerModule,
    StylistPickerModule
  ],
  declarations: [UniversalSearchComponent],
  exports: [ UniversalSearchComponent],
})
export class UniversalSearchComponentModule {}
